import {
  CheckCircleRounded,
  ErrorRounded,
  InfoRounded,
  WarningRounded,
} from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { Toast as ToastType, ToastVariant } from '@/types';

export const ANIMATION_MS = 300;
const iconSx = { color: 'text.contrast', width: 16, height: 16 };
const variantConfig: Record<
  ToastVariant,
  { color: string; icon: React.ReactNode }
> = {
  success: {
    color: 'green200',
    icon: <CheckCircleRounded sx={iconSx} />,
  },
  error: {
    color: 'red200',
    icon: <ErrorRounded sx={iconSx} />,
  },
  warning: {
    color: 'orange200',
    icon: <WarningRounded sx={iconSx} />,
  },
  info: {
    color: 'blue200',
    icon: <InfoRounded sx={iconSx} />,
  },
};

export const Toast = ({
  isVisible,
  variant,
  message,
}: {
  isVisible: boolean;
  variant: ToastType['variant'];
  message: ToastType['message'];
}) => {
  const { color, icon } = variantConfig[variant];

  return (
    <Box
      sx={{
        width: '100%',
        p: 2,
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
        opacity: isVisible ? 1 : 0,
        transition: `transform ${ANIMATION_MS}ms ease-out, opacity ${ANIMATION_MS}ms ease-out`,
      }}>
      {icon}
      <Typography variant="body3SemiBold" sx={{ color: 'text.contrast' }}>
        {message}
      </Typography>
    </Box>
  );
};
